import { GameOver } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadGameOver = createAction(
  '[GameOver Page] Init',
  props<{
    playInstance: string;
    userUuid: string;
    pageIndex?: number;
    pageSize?: number;
    paginated?: boolean;
    silent?: boolean;
    extra?: Record<string, string | number | boolean>;
  }>(),
);
export const updateGameOver = createAction(
  '[GameOver Page] Update game over data',
  props<{
    playInstance: string;
    pageIndex?: number;
    pageSize?: number;
    paginated?: boolean;
  }>(),
);

export const loadGameOverSuccess = createAction(
  '[GameOver/API] Load GameOver Success',
  props<{ gameOver: GameOver; playInstanceId: string }>(),
);

export const loadGameOverFailure = createAction(
  '[GameOver/API] Load GameOver Failure',
  props<{ error: any }>(),
);
